import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { loadEffect, SaveStatus, LoadState_map, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector, useDispatch } from "../../Redux/Store.js";
import * as react from "react";
import { filter as filter_1, iterate, tryFind as tryFind_1, FSharpMap__Add, exists, map as map_1, toList, empty } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { ofArray, length, iterate as iterate_1, cons, sortBy, tryFind, isEmpty, exists as exists_1, filter, collect, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { PeriodModule_toTranslation, PeriodModule_toString, ProductModule_toTranslation, ProductModule_toString, ProductModule_toInt, PeriodModule_ofString, ProductModule_ofInt } from "../../DomainTypes.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { uncurry, comparePrimitives, safeHash, equals, numberHash } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { UseTemplateWhenModule_toTranslation, UseTemplateWhenModule_toString, UseTemplateWhenModule_toInt, UseTemplateWhenModule_ofInt } from "./Model.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { createNewFeeTemplate, saveFeeTemplate, loadActivateFeeTemplate, deactivateFeeTemplate, loadContractAttributes as loadContractAttributes_1, loadAllFeeTemplates as loadAllFeeTemplates_1 } from "./Api.js";
import { loadContractTypesThunk } from "../../Api/Contract.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { FeeTemplateTableProps, renderFeeTemplateTable, FeeTemplateModalProps, toFeeTemplateDTO, renderFeeTemplateModal } from "./Common.js";
import { error } from "../../Components/Message/Message.js";
import { isNullOrWhiteSpace, join, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { dotsLoading } from "../../ViewUtils.js";
import { CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { DropdownProps, DropdownProps_get_GetDefault, Dropdown } from "../../Components/StatefulFormFields/Dropdown.js";
import { stackClasses, truncateWithEllipsis } from "../../Utils.js";
import { HTMLAttr, Prop } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { CollapseProps, CollapseProps_get_GetDefault, collapse } from "../../Components/Collapse/Collapse.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import "../../../src/Containers/FeeTemplates/View.scss";


export class FeeTemplateProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function FeeTemplateProps$reflection() {
    return record_type("Containers.FeeTemplates.View.FeeTemplateProps", [], FeeTemplateProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_8, inputRecord_1, Id_2, arg_23, arg_22, inputRecord_2, PrimaryText, text, children_13, inputRecord_4, Id_4, arg_26, arg_25, inputRecord_5, PrimaryText_1, text_1, children_18, inputRecord_7, Id_6, arg_29, arg_28, inputRecord_8, PrimaryText_2, text_2, children_23, inputRecord_10, Id_8, arg_32, arg_31, inputRecord_11, PrimaryText_3, text_3, arg_33, inputRecord_12, children_32, children_38, children_34, children_40, props_45, children_44, inputRecord_13, HeadingHtml, children_42;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const contractTypesLoadState = useSelector((state_1) => state_1.Contract.ContractTypes);
    const inactiveFeesRef = react.useRef(void 0);
    const selectAllContractTypesState = react.useState(false);
    const selectAllProductsState = react.useState(false);
    const selectAllPeriodsState = react.useState(false);
    const selectAllUseWhenState = react.useState(false);
    const showOnlyNonContractTypeOrProductState = react.useState(false);
    const contractAttributesLoadState = react.useState(new LoadState$2(0));
    const selectedContractTypesState = react.useState(empty());
    const productsLoadState = react.useMemo(() => LoadState_map((arg_3) => map(ProductModule_ofInt, List_distinct(map((tupledArg) => tupledArg[1], toList(map_1((ctc, ct) => ct.ProductNr, arg_3))), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    })), contractTypesLoadState), [contractTypesLoadState]);
    const selectedProductsState = react.useState(empty());
    const editFeeTemplateModalState = react.useState(void 0);
    const createFeeTemplateModalIsOpenState = react.useState(false);
    const feeTemplatesState = react.useState(new LoadState$2(0));
    const periodsLoadState = react.useMemo(() => LoadState_map((arg_4) => List_distinct(map((ft) => PeriodModule_ofString(ft.PeriodDesc), arg_4), {
        Equals: equals,
        GetHashCode: safeHash,
    }), feeTemplatesState[0]), [feeTemplatesState[0]]);
    const selectedPeriodsState = react.useState(empty());
    const useWhenLoadState = react.useMemo(() => LoadState_map((arg_5) => List_distinct(collect((ft_1) => map(UseTemplateWhenModule_ofInt, ft_1.UseWhen), arg_5), {
        Equals: equals,
        GetHashCode: safeHash,
    }), feeTemplatesState[0]), [feeTemplatesState[0]]);
    const selectedUseWhenState = react.useState(empty());
    const filteredFeeTemplates = react.useMemo(() => LoadState_map((arg_9) => {
        let feeTemplates_4;
        let feeTemplates_3;
        let feeTemplates_2;
        let feeTemplates_1;
        const feeTemplates = arg_9;
        const matchValue = exists((key_1, value) => value, selectedContractTypesState[0]);
        feeTemplates_1 = (matchValue ? filter((ft_2) => exists_1((ctc_1) => exists((key_2, isSelected) => {
            if (key_2 === ctc_1) {
                return isSelected;
            }
            else {
                return false;
            }
        }, selectedContractTypesState[0]), ft_2.ContractTypeCodes), feeTemplates) : feeTemplates);
        const matchValue_1 = exists((key_3, value_1) => value_1, selectedProductsState[0]);
        feeTemplates_2 = (matchValue_1 ? filter((ft_3) => exists_1((productNr_1) => exists((key_4, isSelected_1) => {
            if (ProductModule_toInt(key_4) === productNr_1) {
                return isSelected_1;
            }
            else {
                return false;
            }
        }, selectedProductsState[0]), ft_3.ProductNrs), feeTemplates_1) : feeTemplates_1);
        const matchValue_2 = exists((key_5, value_2) => value_2, selectedPeriodsState[0]);
        feeTemplates_3 = (matchValue_2 ? filter((ft_4) => exists((key_6, isSelected_2) => {
            if (equals(PeriodModule_ofString(ft_4.PeriodDesc), key_6)) {
                return isSelected_2;
            }
            else {
                return false;
            }
        }, selectedPeriodsState[0]), feeTemplates_2) : feeTemplates_2);
        const matchValue_3 = exists((key_7, value_3) => value_3, selectedUseWhenState[0]);
        feeTemplates_4 = (matchValue_3 ? filter((ft_5) => exists_1((useWhen) => exists((key_8, isSelected_3) => {
            if (UseTemplateWhenModule_toInt(key_8) === useWhen) {
                return isSelected_3;
            }
            else {
                return false;
            }
        }, selectedUseWhenState[0]), ft_5.UseWhen), feeTemplates_3) : feeTemplates_3);
        const matchValue_4 = showOnlyNonContractTypeOrProductState[0];
        if (matchValue_4) {
            return filter((ft_6) => {
                if (isEmpty(ft_6.ContractTypeCodes)) {
                    return isEmpty(ft_6.ProductNrs);
                }
                else {
                    return false;
                }
            }, feeTemplates_4);
        }
        else {
            return feeTemplates_4;
        }
    }, feeTemplatesState[0]), [feeTemplatesState[0], selectedContractTypesState[0], selectedProductsState[0], selectedPeriodsState[0], selectedUseWhenState[0], showOnlyNonContractTypeOrProductState[0]]);
    const feeTemplateSaveState = react.useState(new SaveStatus(0));
    const loadAllFeeTemplates = () => {
        feeTemplatesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadAllFeeTemplates_1(props.GlobalDependencies.ClientNr), (_arg_2) => {
            const result = _arg_2;
            const arg_12 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0]));
            feeTemplatesState[1](arg_12);
            return singleton.Zero();
        })));
    };
    react.useEffect(() => {
        reduxDispatch(loadContractTypesThunk(props.GlobalDependencies.ClientNr, false));
        loadAllFeeTemplates();
        loadEffect(() => loadContractAttributes_1(props.GlobalDependencies.ClientNr), (arg_10) => {
            contractAttributesLoadState[1](arg_10);
        });
    }, [props.GlobalDependencies]);
    const deactivateFeeTemplateFn = (feeTemplateNrStr) => {
        let a;
        startImmediate((a = deactivateFeeTemplate(props.GlobalDependencies.ClientNr, parse(feeTemplateNrStr, 511, false, 32)), singleton.Delay(() => singleton.Bind(a, (_arg_6) => singleton.Return(loadAllFeeTemplates())))));
    };
    const activateFeeTemplateFn = (feeTemplateNrStr_1) => {
        let a_2;
        startImmediate((a_2 = loadActivateFeeTemplate(props.GlobalDependencies.ClientNr, parse(feeTemplateNrStr_1, 511, false, 32)), singleton.Delay(() => singleton.Bind(a_2, (_arg_8) => singleton.Return(loadAllFeeTemplates())))));
    };
    const editFeeTemplateModalHtml = react.useMemo(() => {
        const matchValue_5 = [editFeeTemplateModalState[0], feeTemplatesState[0], contractAttributesLoadState[0]];
        let pattern_matching_result, contractAttributes, feeTemplateNr, feeTemplates_6;
        if (matchValue_5[0] != null) {
            if (matchValue_5[1].tag === 2) {
                if (matchValue_5[2].tag === 2) {
                    pattern_matching_result = 0;
                    contractAttributes = matchValue_5[2].fields[0];
                    feeTemplateNr = matchValue_5[0];
                    feeTemplates_6 = matchValue_5[1].fields[0];
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const matchValue_6 = tryFind((ft_7) => (ft_7.FeeTemplateNr === parse(feeTemplateNr, 511, false, 32)), feeTemplates_6);
                if (matchValue_6 != null) {
                    return renderFeeTemplateModal(new FeeTemplateModalProps(props.GlobalDependencies, matchValue_6, () => {
                        editFeeTemplateModalState[1](void 0);
                    }, (ft_8) => {
                        let a_6, a_4, vm;
                        startImmediate((a_6 = ((a_4 = ((vm = ft_8, (feeTemplateSaveState[1](new SaveStatus(1)), singleton.Delay(() => singleton.Bind(saveFeeTemplate(props.GlobalDependencies.ClientNr, vm.FeeTemplateNr, toFeeTemplateDTO(vm)), (_arg_3) => {
                            const result_1 = _arg_3;
                            const arg_14 = (result_1.tag === 1) ? (new SaveStatus(3, result_1.fields[0])) : (new SaveStatus(2));
                            feeTemplateSaveState[1](arg_14);
                            return singleton.Return("Something other than unit needs to be returned here otherwise we cant Async.map this. This is a Fable issue not an F# issue.");
                        }))))), singleton.Delay(() => singleton.Bind(a_4, (_arg_10) => singleton.Return((editFeeTemplateModalState[1](void 0), "")))))), singleton.Delay(() => singleton.Bind(a_6, (_arg_12) => singleton.Return(loadAllFeeTemplates())))));
                    }, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, contractAttributes));
                }
                else {
                    return error(toText(printf("Could not find FeeTemplate with id: %s"))(feeTemplateNr).split(""));
                }
            }
            case 1: {
                return react.createElement(react.Fragment, {});
            }
        }
    }, [[editFeeTemplateModalState[0], feeTemplatesState[0], contractAttributesLoadState[0]]]);
    const createFeeTemplateModalHtml = react.useMemo(() => {
        const matchValue_7 = [createFeeTemplateModalIsOpenState[0], contractAttributesLoadState[0]];
        let pattern_matching_result_1;
        if (matchValue_7[0]) {
            if (matchValue_7[1].tag === 2) {
                pattern_matching_result_1 = 0;
            }
            else {
                pattern_matching_result_1 = 1;
            }
        }
        else {
            pattern_matching_result_1 = 1;
        }
        switch (pattern_matching_result_1) {
            case 0: {
                return renderFeeTemplateModal(new FeeTemplateModalProps(props.GlobalDependencies, void 0, () => {
                    createFeeTemplateModalIsOpenState[1](false);
                }, (ft_9) => {
                    let a_10, a_8;
                    startImmediate((a_10 = ((a_8 = ((feeTemplateSaveState[1](new SaveStatus(1)), singleton.Delay(() => singleton.Bind(createNewFeeTemplate(props.GlobalDependencies.ClientNr, toFeeTemplateDTO(ft_9)), (_arg_4) => {
                        const result_2 = _arg_4;
                        const arg_15 = (result_2.tag === 1) ? (new SaveStatus(3, result_2.fields[0])) : (new SaveStatus(2));
                        feeTemplateSaveState[1](arg_15);
                        return singleton.Return("Something other than unit needs to be returned here otherwise we cant Async.map this. This is a Fable issue not an F# issue.");
                    })))), singleton.Delay(() => singleton.Bind(a_8, (_arg_14) => singleton.Return((createFeeTemplateModalIsOpenState[1](false), "")))))), singleton.Delay(() => singleton.Bind(a_10, (_arg_16) => singleton.Return(loadAllFeeTemplates())))));
                }, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, matchValue_7[1].fields[0]));
            }
            case 1: {
                return react.createElement(react.Fragment, {});
            }
        }
    }, [[createFeeTemplateModalIsOpenState[0], contractAttributesLoadState[0]]]);
    let createButtonHtml;
    const children_2 = [main(new ButtonProps(getTranslation("ContractType.FeeTemplate.CreateFeeTemplate"), defaultProps.Content, (_arg_17) => {
        createFeeTemplateModalIsOpenState[1](true);
    }, defaultProps.Disabled, "fee-template-create-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))];
    createButtonHtml = react.createElement("div", {
        className: "fee-templates__create-button mb-2",
    }, ...children_2);
    let errorMessageHtml;
    const matchValue_8 = feeTemplateSaveState[0];
    errorMessageHtml = ((matchValue_8.tag === 3) ? error(matchValue_8.fields[0].split("")) : react.createElement(react.Fragment, {}));
    let contractTypeFilterHtml;
    switch (contractTypesLoadState.tag) {
        case 1: {
            contractTypeFilterHtml = dotsLoading;
            break;
        }
        case 3: {
            contractTypeFilterHtml = error(contractTypesLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            const contractTypesMap = contractTypesLoadState.fields[0];
            const valueAndDisplay = map((tupledArg_2) => {
                let ct_1, children_6, inputRecord, Id_1;
                return [tupledArg_2[0], (ct_1 = tupledArg_2[1], (children_6 = [inputCheckbox((inputRecord = CheckboxInput_get_getDefault(), (Id_1 = toText(printf("report-filter-select-contracttypecode-%s"))(ct_1.ContractTypeCode), new CheckboxInput(inputRecord.Disabled, ct_1.Display, (e) => {
                    selectedContractTypesState[1]((x_3) => FSharpMap__Add(x_3, ct_1.ContractTypeCode, Browser_Types_Event__Event_get_Checked(e)));
                }, defaultArg(tryFind_1(ct_1.ContractTypeCode, selectedContractTypesState[0]), false), Id_1, inputRecord.HTMLProps))))], react.createElement("div", {
                    className: "filters__checkbox",
                }, ...children_6)))];
            }, sortBy((tupledArg_1) => tupledArg_1[1].Display, toList(contractTypesMap), {
                Compare: comparePrimitives,
            }));
            const choooseAllOption = ["", (children_8 = [inputCheckbox((inputRecord_1 = CheckboxInput_get_getDefault(), (Id_2 = toText(printf("report-filter-select-contracttypecode-choose-all")), new CheckboxInput(inputRecord_1.Disabled, (arg_23 = getTranslation("Common.All"), (arg_22 = getTranslation("Common.Choose"), toText(printf("%s %s"))(arg_22)(arg_23))), (e_1) => {
                selectAllContractTypesState[1](Browser_Types_Event__Event_get_Checked(e_1));
                iterate((contractTypeCode_2, _arg_18) => {
                    selectedContractTypesState[1]((x_5) => FSharpMap__Add(x_5, contractTypeCode_2, Browser_Types_Event__Event_get_Checked(e_1)));
                }, contractTypesMap);
            }, selectAllContractTypesState[0], Id_2, inputRecord_1.HTMLProps))))], react.createElement("div", {
                className: "filters__checkbox filters__checkbox--choose-all",
            }, ...children_8))];
            contractTypeFilterHtml = Dropdown((inputRecord_2 = DropdownProps_get_GetDefault(), (PrimaryText = ((text = truncateWithEllipsis(30, join(", ", map((tupledArg_3) => tupledArg_3[0], toList(filter_1((cct_1, value_5) => value_5, selectedContractTypesState[0]))))), isNullOrWhiteSpace(text) ? getTranslation("Common.Choose") : text)), new DropdownProps(cons(choooseAllOption, valueAndDisplay), getTranslation("Common.ContractType"), PrimaryText, (value_7) => {
            }, "400px"))));
            break;
        }
        default: {
            contractTypeFilterHtml = react.createElement(react.Fragment, {});
        }
    }
    let productsFilterHtml;
    switch (productsLoadState.tag) {
        case 1: {
            productsFilterHtml = dotsLoading;
            break;
        }
        case 3: {
            productsFilterHtml = error(productsLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            const products = productsLoadState.fields[0];
            const valueAndDisplay_1 = map((product_1) => {
                let product, children_11, inputRecord_3, Id_3, arg_24;
                return [ProductModule_toString(product_1), (product = product_1, (children_11 = [inputCheckbox((inputRecord_3 = CheckboxInput_get_getDefault(), (Id_3 = ((arg_24 = ProductModule_toString(product), toText(printf("report-filter-select-product-%s"))(arg_24))), new CheckboxInput(inputRecord_3.Disabled, ProductModule_toTranslation(getTranslation, product), (e_2) => {
                    selectedProductsState[1]((x_6) => FSharpMap__Add(x_6, product, Browser_Types_Event__Event_get_Checked(e_2)));
                }, defaultArg(tryFind_1(product, selectedProductsState[0]), false), Id_3, inputRecord_3.HTMLProps))))], react.createElement("div", {
                    className: "filters__checkbox",
                }, ...children_11)))];
            }, products);
            const choooseAllOption_1 = ["", (children_13 = [inputCheckbox((inputRecord_4 = CheckboxInput_get_getDefault(), (Id_4 = toText(printf("report-filter-select-product-choose-all")), new CheckboxInput(inputRecord_4.Disabled, (arg_26 = getTranslation("Common.All"), (arg_25 = getTranslation("Common.Choose"), toText(printf("%s %s"))(arg_25)(arg_26))), (e_3) => {
                selectAllProductsState[1](Browser_Types_Event__Event_get_Checked(e_3));
                iterate_1((product_2) => {
                    selectedProductsState[1]((x_7) => FSharpMap__Add(x_7, product_2, Browser_Types_Event__Event_get_Checked(e_3)));
                }, products);
            }, selectAllProductsState[0], Id_4, inputRecord_4.HTMLProps))))], react.createElement("div", {
                className: "filters__checkbox filters__checkbox--choose-all",
            }, ...children_13))];
            productsFilterHtml = Dropdown((inputRecord_5 = DropdownProps_get_GetDefault(), (PrimaryText_1 = ((text_1 = truncateWithEllipsis(30, join(", ", map((tupledArg_4) => ProductModule_toTranslation(getTranslation, tupledArg_4[0]), toList(filter_1((product_3, value_9) => value_9, selectedProductsState[0]))))), isNullOrWhiteSpace(text_1) ? getTranslation("Common.Choose") : text_1)), new DropdownProps(cons(choooseAllOption_1, valueAndDisplay_1), getTranslation("Common.Product"), PrimaryText_1, (value_11) => {
            }, "400px"))));
            break;
        }
        default: {
            productsFilterHtml = react.createElement(react.Fragment, {});
        }
    }
    let periodsFilterHtml;
    switch (periodsLoadState.tag) {
        case 1: {
            periodsFilterHtml = dotsLoading;
            break;
        }
        case 3: {
            periodsFilterHtml = error(periodsLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            const periods = periodsLoadState.fields[0];
            const valueAndDisplay_2 = map((period_1) => {
                let period, children_16, inputRecord_6, Id_5, arg_27;
                return [PeriodModule_toString(period_1), (period = period_1, (children_16 = [inputCheckbox((inputRecord_6 = CheckboxInput_get_getDefault(), (Id_5 = ((arg_27 = PeriodModule_toString(period), toText(printf("report-filter-select-period-%s"))(arg_27))), new CheckboxInput(inputRecord_6.Disabled, PeriodModule_toTranslation(getTranslation, period), (e_4) => {
                    selectedPeriodsState[1]((x_8) => FSharpMap__Add(x_8, period, Browser_Types_Event__Event_get_Checked(e_4)));
                }, defaultArg(tryFind_1(period, selectedPeriodsState[0]), false), Id_5, inputRecord_6.HTMLProps))))], react.createElement("div", {
                    className: "filters__checkbox",
                }, ...children_16)))];
            }, periods);
            const choooseAllOption_2 = ["", (children_18 = [inputCheckbox((inputRecord_7 = CheckboxInput_get_getDefault(), (Id_6 = toText(printf("report-filter-select-period-choose-all")), new CheckboxInput(inputRecord_7.Disabled, (arg_29 = getTranslation("Common.All"), (arg_28 = getTranslation("Common.Choose"), toText(printf("%s %s"))(arg_28)(arg_29))), (e_5) => {
                selectAllPeriodsState[1](Browser_Types_Event__Event_get_Checked(e_5));
                iterate_1((period_2) => {
                    selectedPeriodsState[1]((x_9) => FSharpMap__Add(x_9, period_2, Browser_Types_Event__Event_get_Checked(e_5)));
                }, periods);
            }, selectAllPeriodsState[0], Id_6, inputRecord_7.HTMLProps))))], react.createElement("div", {
                className: "filters__checkbox filters__checkbox--choose-all",
            }, ...children_18))];
            periodsFilterHtml = Dropdown((inputRecord_8 = DropdownProps_get_GetDefault(), (PrimaryText_2 = ((text_2 = truncateWithEllipsis(30, join(", ", map((tupledArg_5) => PeriodModule_toTranslation(getTranslation, tupledArg_5[0]), toList(filter_1((period_3, value_13) => value_13, selectedPeriodsState[0]))))), isNullOrWhiteSpace(text_2) ? getTranslation("Common.Choose") : text_2)), new DropdownProps(cons(choooseAllOption_2, valueAndDisplay_2), getTranslation("Common.Period"), PrimaryText_2, (value_15) => {
            }, "400px"))));
            break;
        }
        default: {
            periodsFilterHtml = react.createElement(react.Fragment, {});
        }
    }
    let useWhenFilterHtml;
    switch (useWhenLoadState.tag) {
        case 1: {
            useWhenFilterHtml = dotsLoading;
            break;
        }
        case 3: {
            useWhenFilterHtml = error(useWhenLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            const useWhens = useWhenLoadState.fields[0];
            const valueAndDisplay_3 = map((useWhen_2) => {
                let useWhen_1, children_21, inputRecord_9, Id_7, arg_30;
                return [UseTemplateWhenModule_toString(useWhen_2), (useWhen_1 = useWhen_2, (children_21 = [inputCheckbox((inputRecord_9 = CheckboxInput_get_getDefault(), (Id_7 = ((arg_30 = UseTemplateWhenModule_toString(useWhen_1), toText(printf("report-filter-select-use-when-%s"))(arg_30))), new CheckboxInput(inputRecord_9.Disabled, UseTemplateWhenModule_toTranslation(getTranslation, useWhen_1), (e_6) => {
                    selectedUseWhenState[1]((x_10) => FSharpMap__Add(x_10, useWhen_1, Browser_Types_Event__Event_get_Checked(e_6)));
                }, defaultArg(tryFind_1(useWhen_1, selectedUseWhenState[0]), false), Id_7, inputRecord_9.HTMLProps))))], react.createElement("div", {
                    className: "filters__checkbox",
                }, ...children_21)))];
            }, useWhens);
            const choooseAllOption_3 = ["", (children_23 = [inputCheckbox((inputRecord_10 = CheckboxInput_get_getDefault(), (Id_8 = toText(printf("report-filter-select-use-when-choose-all")), new CheckboxInput(inputRecord_10.Disabled, (arg_32 = getTranslation("Common.All"), (arg_31 = getTranslation("Common.Choose"), toText(printf("%s %s"))(arg_31)(arg_32))), (e_7) => {
                selectAllUseWhenState[1](Browser_Types_Event__Event_get_Checked(e_7));
                iterate_1((useWhen_3) => {
                    selectedUseWhenState[1]((x_11) => FSharpMap__Add(x_11, useWhen_3, Browser_Types_Event__Event_get_Checked(e_7)));
                }, useWhens);
            }, selectAllUseWhenState[0], Id_8, inputRecord_10.HTMLProps))))], react.createElement("div", {
                className: "filters__checkbox filters__checkbox--choose-all",
            }, ...children_23))];
            useWhenFilterHtml = Dropdown((inputRecord_11 = DropdownProps_get_GetDefault(), (PrimaryText_3 = ((text_3 = truncateWithEllipsis(30, join(", ", map((tupledArg_6) => UseTemplateWhenModule_toTranslation(getTranslation, tupledArg_6[0]), toList(filter_1((useWhen_4, value_17) => value_17, selectedUseWhenState[0]))))), isNullOrWhiteSpace(text_3) ? getTranslation("Common.Choose") : text_3)), new DropdownProps(cons(choooseAllOption_3, valueAndDisplay_3), getTranslation("Common.UseWhen"), PrimaryText_3, (value_19) => {
            }, "400px"))));
            break;
        }
        default: {
            useWhenFilterHtml = react.createElement(react.Fragment, {});
        }
    }
    let goToInactiveFeesHtml;
    let pattern_matching_result_2;
    if (filteredFeeTemplates.tag === 2) {
        if (length(filteredFeeTemplates.fields[0]) > 10) {
            pattern_matching_result_2 = 0;
        }
        else {
            pattern_matching_result_2 = 1;
        }
    }
    else {
        pattern_matching_result_2 = 1;
    }
    switch (pattern_matching_result_2) {
        case 0: {
            const children_25 = [(arg_33 = getTranslation("ContractType.FeeTemplate.GoToInactive"), toText(printf("%s ↓"))(arg_33))];
            goToInactiveFeesHtml = react.createElement("div", {
                className: "fee-templates__go-to-inactive",
                onClick: (_arg_19) => {
                    const matchValue_13 = inactiveFeesRef.current;
                    if (matchValue_13 != null) {
                        const element = matchValue_13;
                        element.scrollIntoView(false);
                    }
                },
            }, ...children_25);
            break;
        }
        case 1: {
            goToInactiveFeesHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    const showOnlyUnboundCheckboxHtml = inputCheckbox((inputRecord_12 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_12.Disabled, getTranslation("ContractType.FeeTemplate.ShowUnbound"), (e_8) => {
        const arg_34 = Browser_Types_Event__Event_get_Checked(e_8);
        showOnlyNonContractTypeOrProductState[1](arg_34);
    }, showOnlyNonContractTypeOrProductState[0], "fee-templates-show-unbound-checkbox", inputRecord_12.HTMLProps)));
    let contentHtml;
    switch (filteredFeeTemplates.tag) {
        case 1: {
            contentHtml = dotsLoading;
            break;
        }
        case 3: {
            const children_30 = [error(filteredFeeTemplates.fields[0].split(""))];
            contentHtml = react.createElement("div", {}, ...children_30);
            break;
        }
        case 2: {
            const filteredFeeTemplates_1 = filteredFeeTemplates.fields[0];
            const activeFilteredFeeTemplates = filter((feeTemplate_1) => feeTemplate_1.Active, filteredFeeTemplates_1);
            const inactiveFilteredFeeTemplates = filter((feeTemplate_2) => (!feeTemplate_2.Active), filteredFeeTemplates_1);
            const children_46 = [(children_32 = [getTranslation("ContractType.FeeTemplates")], react.createElement("h1", {}, ...children_32)), editFeeTemplateModalHtml, createFeeTemplateModalHtml, errorMessageHtml, createButtonHtml, (children_38 = [(children_34 = [getTranslation("Common.Filter")], react.createElement("h3", {}, ...children_34)), react.createElement("div", {
                className: "filters__container",
            }, contractTypeFilterHtml, productsFilterHtml, periodsFilterHtml, useWhenFilterHtml), showOnlyUnboundCheckboxHtml], react.createElement("div", {
                className: "fee-templates__filters",
            }, ...children_38)), (children_40 = [goToInactiveFeesHtml, renderFeeTemplateTable(new FeeTemplateTableProps((arg_37) => {
                editFeeTemplateModalState[1](arg_37);
            }, deactivateFeeTemplateFn, activateFeeTemplateFn, activeFilteredFeeTemplates))], react.createElement("div", {
                className: "position-relative",
            }, ...children_40)), (props_45 = [new Prop(3, inactiveFeesRef), new HTMLAttr(65, stackClasses(ofArray(["mt-3", "mb-5"])))], (children_44 = [collapse((inputRecord_13 = CollapseProps_get_GetDefault(), (HeadingHtml = ((children_42 = [getTranslation("ContractType.FeeTemplate.InactiveFeeTemplates")], react.createElement("h3", {
                ["data-translation"]: "ContractType.FeeTemplate.InactiveFeeTemplates",
            }, ...children_42))), new CollapseProps(renderFeeTemplateTable(new FeeTemplateTableProps((arg_40) => {
                editFeeTemplateModalState[1](arg_40);
            }, deactivateFeeTemplateFn, activateFeeTemplateFn, inactiveFilteredFeeTemplates)), HeadingHtml, false))))], react.createElement("div", keyValueList(props_45, 1), ...children_44)))];
            contentHtml = react.createElement("div", {
                className: "fee-templates__vertical-container",
            }, ...children_46);
            break;
        }
        default: {
            contentHtml = react.createElement("p", {}, "...");
        }
    }
    return react.createElement("div", {
        className: "fee-templates",
    }, contentHtml);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeeTemplates\\View.fs", 641);

